"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Emitter = void 0;
class Emitter extends EventTarget {
}
exports.Emitter = Emitter;
